/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Very_Slow_1000msInputs */

const en_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very Slow (1000ms)`)
};

const es_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy lento (1000ms)`)
};

const fr_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Très lent (1000ms)`)
};

const de_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr langsam (1000ms)`)
};

const ja_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常に遅い (1000ms)`)
};

const zh_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`极慢 (1000ms)`)
};

const ar_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بطيء جداً (1000ms)`)
};

const id_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sangat Lambat (1000ms)`)
};

const it_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molto Lento (1000ms)`)
};

const ru_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очень медленно (1000мс)`)
};

const pt_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito Lento (1000ms)`)
};

const ko_very_slow_1000ms = /** @type {(inputs: Very_Slow_1000msInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매우 느림 (1000ms)`)
};

/**
* | output |
* | --- |
* | "Very Slow (1000ms)" |
*
* @param {Very_Slow_1000msInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const very_slow_1000ms = /** @type {((inputs?: Very_Slow_1000msInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Very_Slow_1000msInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_very_slow_1000ms(inputs)
	if (locale === "es") return es_very_slow_1000ms(inputs)
	if (locale === "fr") return fr_very_slow_1000ms(inputs)
	if (locale === "de") return de_very_slow_1000ms(inputs)
	if (locale === "ja") return ja_very_slow_1000ms(inputs)
	if (locale === "zh") return zh_very_slow_1000ms(inputs)
	if (locale === "ar") return ar_very_slow_1000ms(inputs)
	if (locale === "id") return id_very_slow_1000ms(inputs)
	if (locale === "it") return it_very_slow_1000ms(inputs)
	if (locale === "ru") return ru_very_slow_1000ms(inputs)
	if (locale === "pt") return pt_very_slow_1000ms(inputs)
	return ko_very_slow_1000ms(inputs)
});